

exports.__esModule = true;
exports.$xoSidepageAddCardPageComponent = undefined;

var _angular = require('angular');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = require('squid');

var _uiRouter = require('uiRouter');

require('xo-page-components/src/aside-header/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-validation/dist/directive');

require('xo-wallet-components/src/add-card/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidepageAddCardPageComponent = exports.$xoSidepageAddCardPageComponent = _squid.$Component.extend('$xoSidepageAddCardPageComponent', {
    tag: 'xo-sidepage-add-card-page',
    template: _template2['default'],
    scope: {
        token: '=?',
        callbacks: '=?'
    },
    lifecycle: {
        enter: function enter() {
            var interval = (0, _angular.$interval)(function () {
                var el = (0, _jquery2['default'])('#sidepageAddCard');

                if (el) {
                    _angular.$interval.cancel(interval);
                    el.addClass('sidepageAddCardOpen');
                }
            }, 100);
        }
    },
    controller: ['$scope', function ($scope) {
        $scope.billingaddressupdated = {
            value: false
        };
        $scope.isUpdateDebitCard = function () {
            return _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD';
        };
        $scope.token = _angular.$rootScope.token;
        $scope.message = {};
    }]
});

angular.value("$xoSidepageAddCardPageComponent", $xoSidepageAddCardPageComponent);
_angular.$interval;

_angular.$rootScope;

_squid.$Component;

_uiRouter.$stateParams;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidepage-add-card/directive.js
// module id = ./pages/xo-sidepage-add-card/directive.js
// module chunks = 0